/**
 * DevExtreme (esm/__internal/scheduler/utils/data_accessor/data_accessor.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { isDefined } from "../../../core/utils/m_type";
export class DataAccessor {
  constructor() {
    this.getter = {};
    this.setter = {};
  }
  updateExpressions(fields) {
    Object.entries(fields).forEach(_ref => {
      let [key, value] = _ref;
      return this.updateExpression(key, value);
    });
  }
  get(field, obj) {
    if (this.getter[field]) {
      return this.getter[field](obj);
    }
    return;
  }
  set(field, obj, value) {
    if (this.setter[field]) {
      this.setter[field](obj, value);
    }
    return this;
  }
  has(field) {
    return isDefined(this.getter[field]);
  }
}